<template>
    <div>
        <div class="imageModal" v-if="imageModalSource !== ''" v-on:click="imageModalSource = ''">
            <img :src="imageModalSource"/>
            <button class="button btn-top-right">X</button>
        </div>

        <div class="module-hero">
            <router-link :to="{path: '/' + currentLocale}"><div class="cover-link"></div></router-link>

            <div>
                <img :src="'../../static/'+ currentLocale +'/hero-'+ herosrc +'.jpg'" alt=""
                     class="d-none d-md-block img-hero">
                <img :src="'../../static/'+ currentLocale +'/mobiili-hero-'+ herosrc +'.jpg'" alt=""
                     class="d-md-none img-hero">
            </div>
       
            <div class="cursor-pointer" v-if="allCompleted()" v-on:click="goToBadge()">
                <img src="../../assets/icons/icon-osaamismerkki-banner.png" alt="" class="img-banner">
            </div>
            <img src="../../assets/icons/icon-osaamismerkki-banner.png" alt="" class="img-banner banner-faded" v-else>
        </div>
        <HeroStart v-bind:pid="pid" ref="navi"/>
        <Transit
                v-bind:pid="pid"
                v-bind:pids="pids"
                v-bind:colorclass="colorclass"
                v-on:next="nextModule()"
                v-on:imagePopup="imagePopup"/>
    </div>
</template>
<script>
  import HeroStart from '@/views/components/HeroStart'
  import Transit from '@/views/components/Transit'
  import secretStore from '../../utils/localstorage'

  export default {
    components: {
      HeroStart,
      Transit
    },
    data: function () {
      return {
        imageModalSource: ''
      }
    },
    props: {
      pid: null,
      pids: [],
      colorclass: '',
      herosrc: ''
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
    methods: {
      nextModule: function () {
        if (this.allCompleted()) {
          this.goToBadge()
        }
        else {
          this.$refs.navi.goToNext()
        }
      },
      allCompleted: function () {
        var modules = ['9', '25', '26', '27', '28']
        for (var module of modules) {
          if (!secretStore.getValue(module)) {
            return false
          }
        }
        return true
      },
      goToBadge: function () {
        this.$router.push({path: 'osaamismerkki'})
      },
      imagePopup: function (src) {
        this.imageModalSource = src
      }
    },
    created: function () {
      this.$emit('showLogin')
    }
  }
</script>
<style lang="scss">

    // link cover
    .cover-link {
        width: 14.9%;
        height: 81%;
        position: absolute;
        opacity: 0.5;
        left: 2.1%;
        top: 0;
        cursor: pointer;
        @media(max-width:767.98px) {
            display:none;
        }
    }

    // Modal
    .imageModal {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1100;
        background-color: rgba(0,0,0,0.8);
        cursor: pointer;
        img {
            position: fixed;
            width: 100%;
            height: auto;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .btn-top-right{
        position: fixed;
        top: 1em;
        right: 1em;
        cursor: pointer;
        color: #000;
        width: 50px;
        padding: 0.5em 1em;
    }

    .banner-faded {
        opacity: 0.3;
    }
</style>


// WEBPACK FOOTER //
// src/views/components/ContentUnit.vue